<template>
    <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;">
            <el-form :inline="true" :model="filters" :size="size">
                <el-form-item label="合作方" prop="partnersId">
                    <el-select
                        remote
                        filterable
                        clearable
                        v-model="filters.partnersId"
                        placeholder="请输入合作方"
                        style="width:100%"
                    >
                        <el-option
                            v-for="item in partnersList"
                            :key="item.partnersId"
                            :label="item.partnersName"
                            :value="item.partnersId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-search" label="搜索" perms="wish:partners:list" type="primary" @click="findPage({pageRequest:{current: 1,size: 10}})"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-plus" label="新增" perms="wish:partners:add" type="success" @click="handleAdd"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-upload" label="批量更新" perms="wish:partners:batchUpdate" type="warning" @click="handleUpdate"></perm-button>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="el-icon-download" label="导出" perms="wish:partners:export" type="danger" @click="handleExport"></perm-button>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-setting" label="" type="primary" @click="handleSetExport">选择导出字段</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="toolbar" style="float:right;padding-top:10px;padding-right:15px;">
            <!--表格显示列界面-->
        </div>
        <table-column-filter-dialog
            ref="tableColumnFilterDialog"
            :columns="columns"
            @handleFilterColumns="handleFilterColumns">
        </table-column-filter-dialog>
        <!--表格树内容栏-->
        <perm-table
            :page="page"
            :columns="columns"
            :selectionChange="selectionChange"
            :handleCurrentHandle="handleCurrentHandle"
            :loading="loading"
            size="mini"
            @findPage="findPage"
            @handleEdit="handleEdit"
            @handleDelete="handleDelete"
            permsEdit="wish:partners:update"
            permsDelete="wish:partners:delete">
        </perm-table>
        <!-- 新增修改界面 -->
        <el-dialog :title="!dataForm.partnersId ? '新增合作方' : '修改合作方'" width="30%"
                   :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancel">
            <el-form
                :model="dataForm"
                :rules="dataRule"
                ref="dataForm"
                @keyup.enter.native="submitForm()"
                label-width="100px"
                :size="size"
                style="text-align:left;">
                <el-form-item label="合作方名称" prop="partnersName">
                    <el-input v-model="dataForm.partnersName" placeholder="合作方名称"></el-input>
                </el-form-item>
                <el-form-item label="合作方渠道" prop="channelName" >
                    <el-select
                        remote
                        filterable
                        clearable
                        @change='getChannelByName'
                        :remote-method="getParentChannelList"
                        v-model="dataForm.channelName"
                        placeholder="请输入合作方渠道"
                        style="width:100%">
                        <el-option
                            v-for="item in parentChannelList"
                            :key="item.channelName"
                            :label="item.channelName"
                            :value="item.channelName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系人名称" prop="userName">
                    <el-input v-model="dataForm.userName" placeholder="联系人名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人职务" prop="position">
                    <el-input v-model="dataForm.position" placeholder="联系人职务"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="phone">
                    <el-input v-model="dataForm.phone" placeholder="联系方式"></el-input>
                </el-form-item>
                <el-form-item label="联系地址" prop="address">
                    <el-input v-model="dataForm.address" placeholder="联系地址"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="dataForm.remark" placeholder="备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :size="size"  @click="cancel">取消</el-button>
                <el-button :size="size"  type="primary" :loading="editLoading" @click="submitForm()">确认</el-button>
            </span>
        </el-dialog>
        <!-- 导出 -->
        <div v-if="showExport">
            <province-stat-data
                :exportType='113'
                :exportBatch ='114'
                :tableId="29"
                :isWishPartners='true'
                :dataIDFlag='true'
                :dataYearFlag="false"
                :provinceFlag='false'
                :jonitFlag='false'
                :schoolFlag='false'
                :title='"合作方表导出"'
                :fileName='fieldNames'
                @hideDialog='hideDialog'>
            </province-stat-data>
        </div>
        <!-- 配置导出字段 -->
        <el-dialog :visible.sync="showTemplate" width="70%" title="配置导出字段">
            <div style="display:flex;justify-content:space-around;flex-flow:wrap;" >
                <div class="mar-right" :class="index === 9 ? 'magin-0' : ''" v-for="(item, index) in options" :key="index">
                    <div style="margin: 10px 20px 15px;">{{item.chName}}</div>
                    <div style="margin: 10px 20px 25px;">
                        <el-checkbox v-model="item.selected">{{item.engName}}</el-checkbox>
                    </div>
                </div>
            </div>
            <div>
                <div style="display:flex;justify-content:flex-end;padding:6px 60px 0 0">
                    <div>
                        <el-button class='selectall' @click="selectAllItem">全选</el-button>
                        <el-button class='cancelselect' @click="cancelSelectAllItem">取消全选</el-button>
                    </div>
                </div>
                <div class="footer-box">
                    <el-button @click='cancelOperation'>取消</el-button>
                    <el-button @click='finishSet'>确定</el-button>
                    <el-button @click='produceTemp'>生成导入模板</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 批量更新 -->
        <div v-if="showUpdate">
            <batch-update
                :importitle="'合作方批量更新'"
                :importType='115'
                :importableId = '29'
                :isWishPartners = 'true'
                @closeImport = 'closeUpdate'
            >
            </batch-update>
        </div>
    </div>
</template>

<script>
import PopupTreeInput from '../../Component/PopupTreeInput/Index'
import PermButton from '../../Component/PermButton/Index'
import PermTable from '../../Component/PermTable/Index'
import TableColumnFilterDialog from '../../Component/TableColumnFilterDialog/Index'
import BatchUpdate from '../../Component/batchUpdate/Index.vue'
import ImportComponent from '../../Component/ImportData/Index'
import ProvinceStatData from '../../Component/ExportProvinceData/provinceStatData.vue'
import { uploadUrl } from '../../../utils/global'

export default {
    name: 'Partners',
    components: {
        PermTable,
        PermButton,
        PopupTreeInput,
        TableColumnFilterDialog,
        ProvinceStatData,
        BatchUpdate,
        ImportComponent
    },
    data: function() {
        return {
            options: [],
            size: 'small',
            filterColumns: [],
            columns: [],
            filters: {
                partnersId: '',
                channel: '',
                channelName: '',
                userName: ''
            },
            page: {},
            pageRequest: {
                current: 1,
                size: 10
            },
            partnersList: [],
            loading: false,
            dialogVisible: false,
            editLoading: false,
            dataForm: {
                partnersId: '',
                partnersName: '',
                dataYear: '',
                showFlag: false,
                mobileAuth: 0,
                userName: '',
                address: '',
                position: '',
                phone: '',
                remark: ''
            },
            mobileAuthList: [
                { key: 0, label: '是', value: 0 },
                { key: 1, label: '否', value: 1 }
            ],
            dataRule: {
                partnersName: [{ required: true, message: '合作方名称不能为空', trigger: 'blur' }],
                dataYear: [{ required: true, message: '年份不能为空', trigger: 'blur' }],
                channelName: [{ required: true, message: '渠道不能为空', trigger: 'blur' }],
                // channelName: [{ required: true, message: '渠道不能为空', trigger: 'blur' }],
                userName: [{ required: true, message: '联系人名称不能为空', trigger: 'blur' }],
                position: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
                phone: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
                address: [{ required: true, message: '联系地址不能为空', trigger: 'blur' }]
            },
            years: [2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024].reverse(),
            parentChannelList: [],
            showExport: false,
            fieldNames: [],
            showTemplate: false,
            showUpdate: false
        }
    },
    methods: {
        // 批量更新
        handleUpdate() {
            this.showUpdate = true
        },
        closeUpdate() {
            this.showUpdate = false
        },
        selectAllItem() {
            this.options.forEach(item => {
                if (!item.selected) {
                    item.selected = true
                }
            })
        },
        cancelSelectAllItem() {
            this.options.forEach(item => {
                if (item.selected) {
                    item.selected = false
                }
            })
        },
        handleSetExport() {
            this.showTemplate = true
        },
        cancelOperation() {
            this.showTemplate = false
        },
        finishSet() {
            this.getFileNames()
            this.showTemplate = false
        },
        // 导出
        handleExport() {
            this.showExport = true
        },
        hideDialog() {
            this.showExport = false
        },
        // 根据选择字段，生成模板
        produceTemp() {
            this.getFileNames()
            if (this.fieldNames.length > 0) {
                let str = ''
                let url = ''
                this.fieldNames.forEach((item, index) => {
                    str = index === 0 ? 'fieldNames=' + item : str + '&fieldNames=' + item
                })
                console.log(str)
                url = 'https://testbase.lpswish.com/api/base/download/excel/template' + '?' + `tableId=29` + '&title=' + '合作方信息导入模板&' + str
                const xhr = new XMLHttpRequest()
                var that = this
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            console.log(xhr)
                            window.open(url)
                        } else {
                            const res = JSON.parse(xhr.response)
                            that.$message({ message: res.data.error, type: 'error' })
                            return
                        }
                    }
                }
                xhr.open('get', url)
                xhr.send()
                return
            }
            this.$message({ message: '请选择生成模板字段', type: 'warning' })
        },
        getFileNames() {
            this.options.forEach((item, index) => {
                // debugger
                if (item.selected && this.fieldNames.indexOf(item.engName) === -1) {
                    this.fieldNames.push(item.engName)
                } else if (!item.selected) {
                    if (this.fieldNames.indexOf(item.engName) !== -1) {
                        this.fieldNames.splice(this.fieldNames.indexOf(item.engName), 1)
                    }
                }
            })
            console.log(this.fieldNames)
        },
        getOptionList() {
            const param = {
                tableId: 29
            }
            this.$api.Tkinfo.getOptionList(param).then(res => {
                if (res.success) {
                    res.data.forEach(item => {
                        const optionItem = {
                            chName: item.columnDesc,
                            engName: item.columnName,
                            selected: false
                        }
                        this.options.push(optionItem)
                    })
                    return
                }
                this.$message({
                    message: res.message
                })
            })
        },
        cancel: function() {
            this.dialogVisible = false
            this.$nextTick(() => {
                this.$refs.dataForm.resetFields()
            })
        },
        // 初始化表格
        initColumns: function() {
            this.columns = [
                { prop: 'partnersId', label: '合作方ID', minWidth: 120 },
                { prop: 'partnersName', label: '合作方名称', minWidth: 120 },
                { prop: 'channelName', label: '渠道名称', minWidth: 120 },
                { prop: 'userName', label: '联系人', minWidth: 120 }
            ]
            this.filterColumns = JSON.parse(JSON.stringify(this.columns))
        },
        // 表单提交
        submitForm() {
            var callback = (res) => {
                this.handleEditLabel = false
                this.editLoading = false
                if (res.success) {
                    this.$message({ message: '操作成功', type: 'success' })
                    this.$refs['dataForm'].resetFields()
                    this.dialogVisible = false
                    // 当前页
                    this.findPage(null)
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            }
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true
                        for (let i = 0; i < this.parentChannelList.length; i++) {
                            if (this.parentChannelList[i].channelName === this.dataForm.channelName) {
                                this.dataForm.channel = this.parentChannelList[i].channel
                                this.dataForm.channelId = this.parentChannelList[i].channelId
                                break
                            }
                        }
                        const params = Object.assign({}, this.dataForm)
                        debugger


                        if (!this.handleEditLabel) {
                            this.$api.partners.addWishPartners(params).then(res => {
                                callback(res)
                            })
                        } else {
                            this.$api.partners.updateWishPartners(params).then(res => {
                                callback(res)
                            })
                        }
                    })
                }
            })
        },
        // 获取分页数据
        findPage: function(data) {
            this.loading = true
            // debugger
            if (data != null) {
                this.pageRequest = data.pageRequest
            }
            let param = {
                partnersId: this.filters.partnersId
            }
            param = Object.assign(param, this.pageRequest)
            this.$api.partners.getWishPartnersPage(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }
                this.page = res.data
                this.loading = false
            }).then(data != null ? data.callback : '')
        },
        selectionChange(selections) {
            console.log(selections)
        },
        handleCurrentHandle: function(val) {
            console.log('handleCurrentHandle>>' + val)
        },
        // 显示新增界面
        handleAdd: function() {
            this.dialogVisible = true
            this.dataForm = {
                dataYear: '',
                showFlag: false
            }
        },
        // 显示编辑界面
        handleEdit: function(data) {
            this.dialogVisible = true
            this.handleEditLabel = true
            Object.assign(this.dataForm, data.row)
            this.dataForm.showFlag = data.row.showFlag === 1
        },
        // 删除
        handleDelete(data) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const params = this.getDeleteIds([], data.row)
                this.$api.partners.deleteWishPartners(params).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '删除成功', type: 'success' })
                    this.findPage(null)
                })
            })
        },
        // 获取删除的包含子分类的id列表
        getDeleteIds(ids, row) {
            ids.push(row.partnersId)
            if (row.children != null) {
                for (let i = 0, len = row.children.length; i < len; i++) {
                    this.getDeleteIds(ids, row.children[i])
                }
            }
            return ids
        },
        // 处理表格列过滤显示
        handleFilterColumns: function(data) {
            this.filterColumns = data.filterColumns
            this.$refs.tableColumnFilterDialog.setDialogVisible(false)
        },
        loadInitData() {
            this.$api.partners.getAllWishPartners().then(res => {
                if (res && !res.success) {
                    return
                }
                this.partnersList = res.data
            })
        },
        getChannelByName() {
            this.$forceUpdate()
        },
        getParentChannelList(params) {
            console.log(params)
            const data = {
                channelName: params,
                parentId: 0
            }
            console.log(data)
            this.$api.channel.getChannelList(data).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    return
                }

                debugger
                this.parentChannelList = res.data.records
                console.log(this.parentChannelList)

            })
        }
    },
    mounted() {
        this.loadInitData()
        this.initColumns()
        this.getOptionList()
        this.findPage()
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Manager/Base/Partners.vue